import { render, staticRenderFns } from "./AdminRegulations.vue?vue&type=template&id=2550a86c&scoped=true"
import script from "./AdminRegulations.vue?vue&type=script&lang=js"
export * from "./AdminRegulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550a86c",
  null
  
)

export default component.exports